import "./polyfill.js";
import "./ambient";
import Vue from "vue";
import App from "./app.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "./plugins/vue-shortkey";
import VueI18n from "vue-i18n";
import { messages } from "./store/textData";
Vue.config.productionTip = false;
Vue.use(VueI18n);

export const i18n = new VueI18n({
  locale: "de",
  fallbackLocale: "de",
  messages
});

new Vue({
  i18n,
  router,
  store,
  // @ts-ignore
  vuetify,
  render: h => h(App)
}).$mount("#app");
